import Navigation from "./Navigation";
import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/styles";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { makeRequest } from "./util";
import useAccountMetadata from "./hooks/useAccountMetadata";

type MTUCountRow = {
  EnvID: string;
  EnvName: string;
  ProjectName: string;
  MTUCount: number;
  YearMonth: string;
};

function PlatformUsagePage() {
  const projects = useAccountMetadata().projects;
  const [mtuData, setMtuData] = useState<MTUCountRow[] | null>(null);

  useEffect(() => {
    makeRequest<[MTUCountRow]>("get_platform_usage_data", {})
      .then((response) => {
        let enriched: MTUCountRow[] = response.data.map((row) => {
          let envName = "unknown";
          let projName = "unknown";
          projects.map((proj) => {
            proj.environments.map((env) => {
              if (env.ID === row.EnvID) {
                envName = env.name;
                projName = proj.name;
              }
            });
          });
          return { ...row, EnvName: envName, ProjectName: projName };
        });
        setMtuData(enriched);
      })
      .catch((error) => {
        console.log("error is:", error);
      });
  }, []);

  //key={row.EnvID}
  return (
    <>
      <h1>Your Platform Usage [WORK IN PROGRESS]</h1>
      <TableContainer component={Paper}>
        <Table size="small" aria-label="MTUs">
          <TableHead>
            <TableRow>
              <TableCell>Project Name</TableCell>
              <TableCell>MTU Count</TableCell>
              <TableCell>Year Month</TableCell>
              <TableCell>Env Name</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {mtuData?.map((row) => (
              <TableRow>
                <TableCell>{row.ProjectName}</TableCell>
                <TableCell>{row.MTUCount}</TableCell>
                <TableCell>{row.YearMonth}</TableCell>
                <TableCell>{row.EnvName}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}

const navigationStyles = makeStyles(() => ({
  navigation: {
    paddingTop: 24,
  },
}));

function PlatformUsagePageWithNavigation() {
  const classes = navigationStyles();

  return (
    <Navigation className={classes.navigation}>
      <PlatformUsagePage />
    </Navigation>
  );
}

export default PlatformUsagePageWithNavigation;
